import { Component, Vue } from 'vue-property-decorator'
import NavBar from '../components/nav-bar/nav-bar.vue'
import FooterBar from '../components/footer-bar/footer-bar.vue'

@Component({
  components: {
    NavBar,
    FooterBar
  }
})

export default class NoSidebar extends Vue {
  
}